__turbopack_context__.v({
  "className": "_2JyYZW_className",
  "variable": "_2JyYZW_variable",
});
